import { Box } from '@mui/material';
import type { ComponentProps } from 'react';

import { PhotoEvidenceDialogGallery } from '../PhotoEvidenceDialogGallery/PhotoEvidenceDialogGallery';
import { type PhotoEvidenceItem, PhotoEvidenceList } from '../PhotoEvidenceList/PhotoEvidenceList';

type Props = {
  slotProps: {
    inlineGallery: ComponentProps<typeof PhotoEvidenceList>;
    dialogGallery: Omit<ComponentProps<typeof PhotoEvidenceDialogGallery>, 'showMoreImages'>;
  };
  'data-testid'?: string;
  handleClick?: (photo: PhotoEvidenceItem) => void;
};

export const PhotoEvidenceGallery = ({ slotProps, 'data-testid': testId, handleClick }: Props) => {
  return (
    <div data-testid={testId}>
      <Box mb={2}>
        <PhotoEvidenceList {...slotProps.inlineGallery} handleClick={handleClick} />
      </Box>
      <PhotoEvidenceDialogGallery
        {...slotProps.dialogGallery}
        showMoreImages={
          slotProps.inlineGallery.evidencePhotos.length <
          slotProps.dialogGallery.slotProps.photoList.evidencePhotos.length
        }
      />
    </div>
  );
};
